module.exports = __webpack_public_path__ + "fa-brands-400.9ddd9f9a879326c121c0.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/webfonts/fa-brands-400.woff
// module id = ../../../../../src/assets/fonts/webfonts/fa-brands-400.woff
// module chunks = styles